import { ErrorService, MortgageCalculationError } from '@hb/services/error/error.service';
import { ButtonKey } from '@hb/modules/global/global.constants';
import { environment } from '@hb/hypotheken-berekening.environment';
import { MaxMortgageComponent } from '@hb/modules/mortgage-calculation/max-mortgage/max-mortgage.component';
import { DisclaimerComponent } from '@hb/modules/mortgage-calculation/disclaimer/disclaimer.component';
import { AssetDeficiencyComponent } from '@hb/modules/mortgage-calculation/asset-deficiency/asset-deficiency.component';
import content from '@hb/hypotheken-berekening.content.json';
import { StoreService } from '@hb/services/store/store.service';
import { MortgageCalculationService } from '@hb/services/mortgage-calculation/mortgage-calculation.service';
import { AppointmentButtonComponent } from '@hb/modules/global/button';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

import { ApError, ApErrorModule } from '@ap/error';
import { MortgageCalculationResponse } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule, ApContentService } from '@ap/content';
import { ApIconButtonLinkComponent } from '@ap/icon-link';
import { ApSpinnerComponent } from '@ap/spinner';
import { ApCardComponent } from '@ap/card';

@Component({
    selector: 'mortgage-calculation',
    templateUrl: './mortgage-calculation.component.html',
    styleUrls: ['./mortgage-calculation.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ApContentModule,
        ApErrorModule,
        ApIconButtonLinkComponent,
        ApSpinnerComponent,
        ApCardComponent,
        AppointmentButtonComponent,
        MaxMortgageComponent,
        DisclaimerComponent,
        AssetDeficiencyComponent
    ]
})
export class MortgageCalculationComponent implements OnInit, OnDestroy {
    private readonly contentService = inject(ApContentService);
    private readonly errorService = inject(ErrorService);

    protected readonly storeService = inject(StoreService);
    protected readonly mortgageCalculationService = inject(MortgageCalculationService);

    protected readonly buttonKey = ButtonKey;

    apError: ApError;

    mortgageCalculationResponse: MortgageCalculationResponse;
    storeServiceSubscription: Subscription;

    ngOnInit(): void {
        this.contentService.addContentItems(content);

        this.setMortgageCalculation();
        this.errorService.error$().subscribe((error) => {
            if (error) {
                this.apError = this.getApError(error);
            } else {
                this.apError = undefined;
            }
        });
    }

    ngOnDestroy(): void {
        this.storeServiceSubscription?.unsubscribe();
    }

    private setMortgageCalculation(): void {
        this.storeServiceSubscription = this.storeService.getMortgage().subscribe((mortgageCalculation) => {
            this.mortgageCalculationResponse = mortgageCalculation;
        });
    }

    showAssetDeficiency(): boolean {
        return this.mortgageCalculationResponse?.mortgage?.asset?.amount < 0;
    }

    showPdfDownload(): boolean {
        return environment.pdfDownloadEnabled;
    }

    private setErrorTitle(isCalculationError: boolean): string {
        return isCalculationError
            ? this.contentService.get('main.mortgage-calculation.calculation-error.title')
            : this.contentService.get('main.mortgage-calculation.error.title');
    }

    private getApError(error: MortgageCalculationError): ApError {
        return {
            showReloadOption: !error.isCalculationError,
            title: this.setErrorTitle(error.isCalculationError)
        } as ApError;
    }
}
